'use client';
import { licenseAttributes } from './helpers';
import { DOMAINS } from '@/helpers/constants';
import { useServer } from '@/modules/server/context/ServerEnvContext';

import { ScLicense } from './styled';

export const FooterLicenseContent = () => {
  const { hostname } = useServer();
  return (
    <ScLicense
      {...(hostname === DOMAINS.OTHER
        ? licenseAttributes.otherDomain
        : licenseAttributes.default)}
    />
  );
};
